import type { CSSProperties, ReactNode } from 'react';

/** A red banner: an optional bold title, then the message (and any actions). `alert` announces it (role=alert). */
export function ErrorBanner({ title, children, alert = false, style, testId }: { title?: ReactNode; children?: ReactNode; alert?: boolean; style?: CSSProperties; testId?: string }) {
  return (
    <div className="banner error" role={alert ? 'alert' : undefined} style={style} data-testid={testId}><div className="banner-body">
      {title && <strong>{title}</strong>}{children}
    </div></div>
  );
}
